const transfers = {
  transfer: "स्थानांतरण", // translated 
  transfers: "स्थानांतरण", // translated 
  dateAndTime: "तिथि और समय", // translated 
  transferFrom: "इससे स्थानांतरित करें", // translated 
  duration: "अवधि", // translated 
  numOfPersons: "व्यक्तियों की संख्या", // translated 
  baggageAllowance: "सामान भत्ता", // translated 
  small: "छोटा", // translated 
  big: "बड़ा", // translated 
  provider: "प्रदाता", // translated 
  vehicle: "वाहन", // translated 
  distance: "दूरी", // translated 
  price: "कीमत", // translated 
  inboundJourney: "इनबाउंड यात्रा", // translated 
  outboundJourney: "प्रस्थान यात्रा", // translated 
  arrivalTime: "आगमन समय", // translated 
  flightDetails: "उड़ान विवरण", // translated 
  inboundPickupDate: "इनबाउंड पिकअप तिथि", // translated 
  outboundPickupDate: "आउटबाउंड पिकअप तिथि", // translated 
  travelInfo: "यात्रा जानकारी", // translated 
  travellersInformation: "यात्रियों की जानकारी", // translated 
  flightsInfo: "उड़ान जानकारी", // translated 
  airportYouAreFlyingFrom: "आप जिस हवाई अड्डे से उड़ान भर रहे हैं", // translated 
  airportYouAreFlyingTo: "आप जिस हवाई अड्डे पर जा रहे हैं", // translated 
  inboundFlightNumber: "आने वाली उड़ान संख्या", // translated 
  outboundFlightNumber: "आउटबाउंड उड़ान संख्या", // translated 
  inboundAirlineName: "आने वाली एयरलाइन का नाम", // translated 
  outboundAirlineName: "आउटबाउंड एयरलाइन का नाम", // translated 
  tripMode: "ट्रिप मोड", // translated 
  airportToPoint: "हवाई अड्डे से बिंदु तक", // translated 
  pointToAirport: "हवाई अड्डे की ओर इशारा करें", // translated 
  roundTrip: "राउंड ट्रिप", // translated 
  destinationPoint: "गंतव्य बिंदु", // translated 
  originPoint: "उत्पत्ति बिंदु", // translated 
  transferType: "स्थानांतरण प्रकार", // translated 
  min: "मिन", // translated 
  max: "अधिकतम", // translated 
  pieces: "टुकड़े", // translated 
  cancelationIs: "रद्दीकरण है", // translated 
};


export default transfers;
